import type { HTMLAttributes, ReactNode } from "react";
import styles from "./PackageRow.module.css";
import { cx } from "../cx";
import { ActionButton } from "../components/ActionButton";
import { Badge } from "../components/Badge";
import { IconBrick } from "../icons/Icon";

export type PackageRowProps = Omit<HTMLAttributes<HTMLDivElement>, "onClick"> & {
  /** 행 제목(앱 문구, 예: productName → "브릭 10,000개"). 기본 수량(보너스 제외), 보너스는 badge 칩 */
  label: ReactNode;
  /** 보너스 칩 "+500" (없으면 칩 없음) */
  badge?: ReactNode;
  priceLabel: string;
  /** 할인 중이면 가격 버튼 위에 "50% ~~3,900원~~"(시안 F06-02 43:734 price-col), 버튼은 브랜드색 */
  discount?: { rate: string; original: string } | undefined;
  /** 강조 행(시안 20,000): critical 테두리 + 브랜드 가격 버튼 */
  highlight?: boolean;
  onClick?: () => void;
  disabled?: boolean;
};

/** 브릭 상점 패키지 행 (시안 F06-02 43:734 · 749:1002 Package/*): 아이콘 28 · "브릭 N개" + 보너스 칩 · 가격 버튼. 높이 80 */
export function PackageRow({ label, badge, priceLabel, discount, highlight = false, onClick, disabled, className, ...rest }: PackageRowProps) {
  return (
    <div className={cx(styles.root, highlight && styles.highlight, className)} {...rest}>
      <IconBrick size={28} />
      <div className={styles.titleRow}>
        <span className={styles.amount}>{label}</span>
        {badge && <Badge tone="brand">{badge}</Badge>}
      </div>
      {discount ? (
        <div className={styles.priceCol}>
          <span className={styles.discount}>
            <span className={styles.rate}>{discount.rate}</span>
            <s className={styles.original}>{discount.original}</s>
          </span>
          <ActionButton size="small" variant="brandSolid" onClick={onClick} disabled={disabled}>
            {priceLabel}
          </ActionButton>
        </div>
      ) : (
        <ActionButton size="small" variant={highlight ? "brandSolid" : "neutralWeak"} onClick={onClick} disabled={disabled}>
          {priceLabel}
        </ActionButton>
      )}
    </div>
  );
}
